const News = (props) => {
  return (
    <section className="news">
      <div className="container">
        <div className="common-title">
          <h2 className="common-title__h2">
            последние <span>новости</span>
          </h2>
          <p className="common-title__subtitle">
            новости проекта из Discord канала
          </p>
        </div>
        <div className="news-wrapper">
          {props.content.news.map((item, key) => (
            <div className="news-item" key={key}>
              <div className="news-item__title">
                <span className="news-item-author">{item.author}</span>
                <span className="news-item-date">{item.published}</span>
              </div>
              <p className="news-item__content">{item.text}</p>
            </div>
          ))}
        </div>
        <a
          href={props.content.discord_url}
          rel="nofollow noopener noreferrer"
          target="_blank"
          className="cta-clear news-cta"
        >
          Перейти в Discord
        </a>
      </div>
    </section>
  );
};

export default News;
